module.exports = __webpack_public_path__ + "img/btn-activity-no-open.950ca54c.png";